import { defineStore } from 'pinia'
import { getGames } from '@/api/lists.js'

export const useGameStore = defineStore('games', {
  state: () => ({
    gameslist: []
  }),
  actions: {
    createGamesList(vm) {
      return new Promise((resolve, reject) => {
        getGames({ vm }).then((data) => {
          this.gameslist = data
          resolve('done')
        }).catch(() => {
          reject('error')
        })
      })
    }
  }
})
